

export const CorrectIcon = () => {

    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.5 0.505371C4.08897 0.505371 0.5 4.09434 0.5 8.50537C0.5 12.9164 4.08897 16.5054 8.5 16.5054C12.911 16.5054 16.5 12.9164 16.5 8.50537C16.5 4.09434 12.911 0.505371 8.5 0.505371ZM12.9712 6.40011L7.8584 11.4728C7.55764 11.7735 7.07644 11.7936 6.75564 11.4928L4.04887 9.02667C3.72807 8.72592 3.70802 8.22467 3.98872 7.90387C4.28947 7.58307 4.79073 7.56302 5.11153 7.86377L7.25689 9.82868L11.8283 5.25725C12.1491 4.93645 12.6504 4.93645 12.9712 5.25725C13.292 5.57805 13.292 6.07931 12.9712 6.40011Z"
                fill="#5B835D" />
        </svg>

    );
};
